import React, { useState, useEffect } from 'react';
import { Plus, Upload, X, Edit3, Trash2, FileText, Eye, Download, Save, FolderPlus, File, ChevronDown, ChevronUp, QrCode } from 'lucide-react';
import axios from 'axios';
import QRCode from "qrcode";

const Investors = () => {
  const [sections, setSections] = useState([]);
  const [subsection, setSubsection] = useState([]);
  const [subsubsection, setSubsubsection] = useState([]);
  const [newSectionName, setNewSectionName] = useState('');
  const [newSubsectionName, setNewSubsectionName] = useState('');
  const [newSubsubsectionName, setNewSubsubsectionName] = useState('');
  const [editingSection, setEditingSection] = useState(null);
  const [editingSubsection, setEditingSubsection] = useState(null);
  const [editingSubsubsection, setEditingSubsubsection] = useState(null);
  const [showAddSection, setShowAddSection] = useState(false);
  const [showAddSubsection, setShowAddSubsection] = useState(null);
  const [showAddSubsubsection, setShowAddSubsubsection] = useState(null);
  const [draggedFiles, setDraggedFiles] = useState([]);
  const [openSubsectionId, setOpenSubsectionId] = useState(null);
  const [openSubsubsectionId, setOpenSubsubsectionId] = useState(null);

  const [qrModalFile, setQrModalFile] = useState(null);          // file object
const [isGeneratingQrFor, setIsGeneratingQrFor] = useState(null); // file._id or null
const [previewQr, setPreviewQr] = useState(null);
const [qrUploadFile, setQrUploadFile] = useState(null);




  useEffect(() => {
  fetchAllSections();
}, []);

  const fetchAllSections = async () => {
  try {
    console.log('Fetching sections from database...');
    
    const response = await fetch('/api/investors/sections', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });
    console.log('response', response);
    if (response.ok) {
      const sectionsData = await response.json();
      console.log('Fetched sections from DB:', sectionsData);
      
      // Set the sections in state - your existing mapping will display them
      setSections(sectionsData);
    } else {
      console.error('Failed to fetch sections. Status:', response.status);
      const errorText = await response.text();
      console.error('Error response:', errorText);
    }
  } catch (error) {
    console.error('Error fetching sections:', error);
  }
};

  const addSection = async() => {
    if (newSectionName.trim()) {
      try {
        // API call to save section
        const response = await fetch('/api/investors/sections', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            secname: newSectionName
          })
        });

        if (response.ok) {
          const savedSection = await response.json();

      // const newSection = {
      //   //id: Date.now(),
      //   name: newSectionName,
      //   subsections: [],
      //   files: []
      // };
      // setSections([...sections, newSection]);
      // setNewSectionName('');
      // setShowAddSection(false);
        setSections([...sections, savedSection]);
        setNewSectionName('');
        setShowAddSection(false);


    } else {
          console.error('Failed to save section');
          // You can add error handling UI here
        }
      } catch (error) {
        console.error('Error saving section:', error);
        // You can add error handling UI here
      }
    }
  };

  const addSubsection = async (sectionId) => {
    console.log('add sub clicked');
    if (newSubsectionName.trim()) {
      try {
        // API call to save subsection
        const response = await fetch(`/api/investors/sections/${sectionId}/subsections`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            subsecname: newSubsectionName
          })
        });
        console.log('response', response);

        if (response.ok) {
          const savedSubsection = await response.json();
          console.log('subsection', savedSubsection);

          //setSubsections(prev => [...prev, savedSubsection]);

      setSections(sections.map(section => {
        if (section._id === sectionId) {
         console.log('entered subsection');
       return {
        ...section,
      //   subsections: [...section.subsections, savedSubsection] // ✅ use actual saved data
      // };
      subsections: [
        ...(section.subsections || []),
        { ...savedSubsection, documents: [] } // Ensure new subsection has `files`
      ]
    }
  }
    return section;
  }));
   setNewSubsectionName('');
      setShowAddSubsection(null);
    } else {
          console.error('Failed to save subsection');
          // You can add error handling UI here
        }
      } catch (error) {
        console.error('Error saving subsection:', error);
        // You can add error handling UI here
      }
  }};

  const addSubsubsection = async (sectionId, subsectionId) => {
    console.log('add subsub clicked');
    if (newSubsubsectionName.trim()) {
      try {
        // API call to save subsection
        const response = await fetch(`/api/investors/sections/${sectionId}/subsections/${subsectionId}/subsubsections`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            subsubsecname: newSubsubsectionName
          })
        });
        console.log('response', response);

        if (response.ok) {
          const savedSubsubsection = await response.json();
          console.log('subsubsection', savedSubsubsection);

          //setSubsections(prev => [...prev, savedSubsection]);
      // setSections(prevSections =>
      //     prevSections.map(section => {
      //       if (section._id === sectionId) {
      //         return {
      //           ...section,
      //           subsections: section.subsections.map(sub => {
      //             //if (sub.subsubsecname === subsubsecname) {
      //               return {
      //                 ...sub,
      //                 subsubsections: [
      //                   ...(sub.subsubsections || []),
      //                   { ...savedSubsubsection, documents: [] }
      //                 ]
      //               };
      //             return sub;
      //           })
      //         };
      //       }
      //       return section;
      //     }));
      setSections(prevSections =>
  prevSections.map(section => {
    if (section._id === sectionId) {
      return {
        ...section,
        subsections: section.subsections.map(sub => {
          if (sub._id === subsectionId) {
            return {
              ...sub,
              subsubsections: [
                ...(sub.subsubsections || []),
                { ...savedSubsubsection, documents: [] }
              ]
            };
          }
          return sub; // Don't forget this!
        })
      };
    }
    return section;
  })
);
      

     
      setNewSubsubsectionName('');
      setShowAddSubsubsection(null);
    } else {
          console.error('Failed to save subsubsection');
          // You can add error handling UI here
        }
      } catch (error) {
        console.error('Error saving subsection:', error);
        // You can add error handling UI here
      }
  }};

      //     return {
      //       ...section,
      //       subsections: [...section.subsections, {
      //         id: Date.now(),
      //         name: newSubsectionName,
      //         files: []
      //       }]
      //     };
      //   }
      //   return section;
      // }));
     

  // const deleteSection = (sectionId) => {
  //   setSections(sections.filter(section => section.id !== sectionId));
  // };

  const deleteSection = async (sectionId) => {
    try {
      // API call to delete section
      const response = await fetch(`/api/investors/sections/${sectionId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      console.log('response', response);
      if (response.ok) {
        setSections(sections.filter(section => section._id !== sectionId));
      } else {
        console.error('Failed to delete section');
        // You can add error handling UI here
      }
    } catch (error) {
      console.error('Error deleting section:', error);
      // You can add error handling UI here
    }
  };

  // const deleteSubsection = (sectionId, subsectionId) => {
  //   setSections(sections.map(section => {
  //     if (section.id === sectionId) {
  //       return {
  //         ...section,
  //         subsections: section.subsections.filter(sub => sub.id !== subsectionId)
  //       };
  //     }
  //     return section;
  //   }));
  // };

  const deleteSubsection = async (sectionId, subsectionId) => {
    try {
      // API call to delete subsection
      console.log('delete sub section');
      const response = await fetch(`/api/investors/sections/${sectionId}/subsections/${subsectionId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      console.log('response', response);
      if (response.ok) {
        setSections(sections.map(section => {
          if (section._id === sectionId) {
            return {
              ...section,
              subsections: section.subsections.filter(sub => sub._id !== subsectionId)
            };
          }
          return section;
        }));
      } else {
        console.error('Failed to delete subsection');
        // You can add error handling UI here
      }
    } catch (error) {
      console.error('Error deleting subsection:', error);
      // You can add error handling UI here
    }
  };

   const deleteSubsubsection = async (sectionId, subsectionId, subsubsectionId) => {
    try {
      // API call to delete subsection
      console.log('delete sub sub section');
      const response = await fetch(`/api/investors/sections/${sectionId}/subsections/${subsectionId}/subsubsections/${subsubsectionId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      console.log('response', response);
      if (response.ok) {
      setSections(sections.map(section => {
        if (section._id === sectionId) {
          return {
            ...section,
            subsections: section.subsections.map(sub => {
              if (sub._id === subsectionId) {
                return {
                  ...sub,
                  subsubsections: sub.subsubsections.filter(subsub => subsub._id !== subsubsectionId)
                };
              }
              return sub;
            })
          };
        }
        return section;
      }));
    } else {
        console.error('Failed to delete subsubsection');
        // You can add error handling UI here
      }
    } catch (error) {
      console.error('Error deleting subsubsection:', error);
      // You can add error handling UI here
    }
  };

const handleFileUpload = async (sectionId, subsectionId, files, subsubsectionId) => {
  console.log('entered file upload');
  if (!files || files.length === 0 || !subsectionId) return;

  try {
    const uploadedFiles = [];

    for (const file of Array.from(files)) {

      const uploadUrlRes = await fetch("/api/s3/upload-url", {
        method:"POST",
        headers: { "Content-Type": "application/json"},
        body: JSON.stringify({
          fileName: file.name,
          fileType: file.type
        })
      })

      if (!uploadUrlRes.ok) {
        console.error("Failed to get S3 upload url");
        continue;
      }

      const { uploadUrl, fileUrl } = await uploadUrlRes.json();
      console.log("S3 File URL:", fileUrl);

      //Upload file directly to S3

      const s3UploadRes = await fetch(uploadUrl, {
        method: "PUT",
        headers: {
          "Content-Type": file.type
        },
        body: file
      });

      if (!s3UploadRes.ok) {
        console.error("Failed to upload file to S3");
        continue;
      }

      // 1️⃣ Upload FILE to Cloudinary
      // const formData = new FormData();
      // formData.append('file', file);
      // formData.append('upload_preset', 'unsigned_pdfs');

      // const cloudinaryResponse = await fetch(
      //   'https://api.cloudinary.com/v1_1/dccuq6ut4/raw/upload',
      //   { method: 'POST', body: formData }
      // );

      // if (!cloudinaryResponse.ok) {
      //   console.error("Failed to upload file to Cloudinary");
      //   continue;
      // }

      // const cloudinaryData = await cloudinaryResponse.json();
      // const docUrl = cloudinaryData.secure_url;

      //console.log("Document URL:", docUrl);

      // 2️⃣ AUTO-GENERATE QR (BASE64)
      //  const qrBase64 = await QRCode.toDataURL(fileUrl, {
      //   width: 300,
      //   margin: 1
      // });
      // const qrBase64 = await QRCode.toDataURL(docUrl, {
      //   width: 300,
      //   margin: 1
      // });

      //Upload QR Base64 to S3
      // const qrUploadUrlRes = await fetch("api/s3/upload-url", {
      //   method:"POST",
      //   headers: { 
      //     "Content-Type": "application/json"
      //   },
      //   body: JSON.stringify({
      //     fileName: `qr-${file.name}.png`,
      //     fileType: "image/png"
      //   })
      // })

      // const { uploadUrl: qrUploadUrl, fileUrl: qrCodeUrl } = await qrUploadUrlRes.json();
      // await fetch(qrUploadUrl, {
      //   method: "PUT",
      //   headers: {
      //     "Content-Type": "image/png"
      //   },
      //   body: await (await fetch(qrBase64)).blob()
      // });

      // 3️⃣ Upload QR BASE64 to Cloudinary 
      // const qrForm = new FormData();
      // qrForm.append("file", qrBase64);
      // qrForm.append("upload_preset", "unsigned_upload"); // <-- create preset

      // const qrUploadRes = await fetch(
      //   "https://api.cloudinary.com/v1_1/dccuq6ut4/upload",
      //   { method: "POST", body: qrForm }
      // );

      // if (!qrUploadRes.ok) {
      //   console.error("QR upload to Cloudinary FAILED");
      //   continue;
      // }

      // const qrData = await qrUploadRes.json();
      // const qrCodeUrl = qrData.secure_url;
      // console.log("QR URL:", qrCodeUrl);

      // 4️⃣ Save DOCUMENT + QR to backend
       const baseEndpoint = `/api/investors/sections/${sectionId}/subsections/${subsectionId}`;
      const apiEndpoint = subsubsectionId
        ? `${baseEndpoint}/subsubsections/${subsubsectionId}/documents`
        : `${baseEndpoint}/documents`;

      const backendResponse = await fetch(apiEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: file.name,
          docUrl: fileUrl,
          //qrCodeUrl: qrCodeUrl, // <-- SAVE QR TOO
        })
      });

      // const baseEndpoint = `/api/investors/sections/${sectionId}/subsections/${subsectionId}`;
      // const apiEndpoint = subsubsectionId
      //   ? `${baseEndpoint}/subsubsections/${subsubsectionId}/documents`
      //   : `${baseEndpoint}/documents`;

      // const backendResponse = await fetch(apiEndpoint, {
      //   method: "POST",
      //   headers: { "Content-Type": "application/json" },
      //   body: JSON.stringify({
      //     name: file.name,
      //     docUrl: docUrl,
      //     qrCodeUrl: qrCodeUrl, // <-- SAVE QR TOO
      //   })
      // });

      if (!backendResponse.ok) {
        console.error("Failed to save document to backend");
        continue;
      }

      const savedDocument = await backendResponse.json();

      uploadedFiles.push({
        _id: savedDocument._id,
        name: savedDocument.name || file.name,
        docUrl: savedDocument.docUrl || fileUrl,
        //qrCodeUrl: savedDocument.qrCodeUrl || qrCodeUrl,
      });

    } // END LOOP

    // 5️⃣ Update UI instantly
    if (uploadedFiles.length > 0) {
      setSections(sections.map(section => {
        if (section._id !== sectionId) return section;

        return {
          ...section,
          subsections: section.subsections.map(subsection => {

            if (subsection._id !== subsectionId) return subsection;

            // SUBSUBSECTION CASE
            if (subsubsectionId) {
              return {
                ...subsection,
                subsubsections: subsection.subsubsections.map(subsub => {
                  if (subsub._id !== subsubsectionId) return subsub;

                  return {
                    ...subsub,
                    documents: [...(subsub.documents || []), ...uploadedFiles],
                  };
                })
              };
            }

            // NORMAL SUBSECTION CASE
            return {
              ...subsection,
              documents: [...(subsection.documents || []), ...uploadedFiles],
            };
          })
        };
      }));
    }

  } catch (error) {
    console.error("Error uploading files:", error);
  }
};

//   const handleFileUpload = async (sectionId, subsectionId, files, subsubsectionId) => {
    
//     console.log('entered file upload');
//      console.log('Parameters received:', { sectionId, subsectionId, files, subsubsectionId });
//   console.log('files type:', typeof files);
//   console.log('files length:', files?.length);
//   console.log('files is array:', Array.isArray(files));
//     if (!files || files.length === 0 || !subsectionId) return;
    

//      try {
//       // Upload files to Cloudinary and save to backend
//       const uploadedFiles = [];
      
//       //for (const fileData of newFiles) {
//       for (const file of Array.from(files)) {
//         // Upload to Cloudinary
//         const formData = new FormData();
//         formData.append('file', file);
//         console.log('formdata', formData);
//         formData.append('upload_preset', 'unsigned_pdfs');
        
//         const cloudinaryResponse = await fetch('https://api.cloudinary.com/v1_1/dccuq6ut4/raw/upload', {
//           method: 'POST',
//           body: formData
//         });
//         console.log('cloudinaryResponse', cloudinaryResponse);
//         if (cloudinaryResponse.ok) {
//           const cloudinaryData = await cloudinaryResponse.json();
//           const docUrl = cloudinaryData.secure_url;
//           console.log('url', docUrl);
//           // Save document to backend
       
//          const baseEndpoint = `/api/investors/sections/${sectionId}/subsections/${subsectionId}`;
//         const apiEndpoint = subsubsectionId 
//           ? `${baseEndpoint}/subsubsections/${subsubsectionId}/documents`
//           : `${baseEndpoint}/documents`;
//         console.log('API Endpoint:', apiEndpoint);
          
//           const backendResponse = await fetch(apiEndpoint, {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json',
//             },
//             body: JSON.stringify({
//               name: file.name,
//               docUrl: docUrl
//             })
//           });
//           //console.log('backendresponse', backendResponse);
//           console.log('backendResponse status:', backendResponse.status);
//           if (backendResponse.ok) {
//             const savedDocument = await backendResponse.json();
//             uploadedFiles.push({
              
//               _id: savedDocument._id ,
//               name: savedDocument.name || file.name,
//               docUrl: savedDocument.docUrl || docUrl,
//             });
//             console.log('uploadedFiles', uploadedFiles);
//           } else {
//             console.error('Failed to save document to backend');
//           }
//         } else {
//           console.error('Failed to upload file to Cloudinary');
//         }
//       }

//     if (uploadedFiles.length > 0) {
//       console.log('Updating sections with uploaded files');
 
//         setSections(sections.map(section => {
//         if (section._id === sectionId) {
//           return {
//             ...section,
//             subsections: section.subsections.map(subsection => {
//               if (subsection._id === subsectionId) {
//                 if (subsubsectionId) {
//                   return {
//                     ...subsection,
//                     subsubsections: subsection.subsubsections.map(subsub => {
//                       if (subsub._id === subsubsectionId) {
//                         const updatedSubsub = {
//                           ...subsub,
//                           documents: [...(subsub.documents || []), ...uploadedFiles]
//                         };
//                         console.log('Updated subsubsection:', updatedSubsub);
//                         return updatedSubsub;
//                       }
//                       return subsub;
//                     })
//                   };
//                 } else {
//                   const updatedSubsection = {
//                     ...subsection,
//                     documents: [...(subsection.documents || []), ...uploadedFiles]
//                   };
//                   console.log('Updated subsection:', updatedSubsection);
//                   return updatedSubsection;
//                 }
//               }
//               return subsection;
//             })
//           };
//         }
//         return section;
//       }));

       
//   } else {
//             console.log('No files were uploaded successfully');
//    }
//   } catch (error) {
//       console.error('Error uploading files:', error);
//       // You can add error handling UI here
//     }
// };

const handleDocumentClick = async (document) => {
  console.log("entered clicked job doc");
  try {
    if (!document?.docUrl) {
      alert("Document URL not available");
      return;
    }
   
    // ✅ CASE 1: Cloudinary (public URLs)
    if (document.docUrl.includes("cloudinary.com")) {
      window.open(document.docUrl, "_blank");
      return;
    }

    // ✅ CASE 2: S3 (private, needs signing)
    if (document.docUrl.includes("amazonaws.com")) {
      const res = await fetch(
        `/api/s3/view-url?fileUrl=${encodeURIComponent(document.docUrl)}`
      );

      if (!res.ok) {
        throw new Error("Failed to get signed URL");
      }

      const { url } = await res.json();
      window.open(url, "_blank");
      return;
    }

    // ❌ Unknown source
    console.error("Unknown document source:", document.docUrl);
    alert("Unsupported document source");

  } catch (err) {
    console.error("Error opening document:", err);
    alert("Unable to open document");
  }
};

// const handleDocumentClick = (document) => {
//     // Handle document click - could open in new tab, download, etc.
//     //window.open(document.url, '_blank');
//     if (document.docUrl) {
//       window.open(document.docUrl, '_blank');
//     } else {
//       console.error('Document URL not found:', document);
//       alert('Document URL not available');
//     }
//   };

 const deleteFile = async (sectionId, subsectionId, fileId, subsubsectionId) => {
  try {
    const getFileEndpoint = subsubsectionId
      ? `/api/investors/sections/${sectionId}/subsections/${subsectionId}/subsubsections/${subsubsectionId}/documents/${fileId}`
      : subsectionId
      ? `/api/investors/sections/${sectionId}/subsections/${subsectionId}/documents/${fileId}`
      : `/api/investors/sections/${sectionId}/documents/${fileId}`;

    const fileResponse = await fetch(getFileEndpoint, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });

    if (fileResponse.ok) {
      const fileData = await fileResponse.json();
      const docUrl = fileData.docUrl;

      const urlParts = docUrl.split('/');
      const fileNameWithExtension = urlParts[urlParts.length - 1];
      const publicId = fileNameWithExtension.split('.')[0];

      const cloudinaryDeleteData = new FormData();
      cloudinaryDeleteData.append('public_id', publicId);
      cloudinaryDeleteData.append('upload_preset', 'unsigned_pdfs');

      const cloudinaryDeleteResponse = await fetch('https://api.cloudinary.com/v1_1/dccuq6ut4/raw/destroy', {
        method: 'POST',
        body: cloudinaryDeleteData
      });

      const apiEndpoint = subsubsectionId
        ? `/api/investors/sections/${sectionId}/subsections/${subsectionId}/subsubsections/${subsubsectionId}/documents/${fileId}`
        : subsectionId
        ? `/api/investors/sections/${sectionId}/subsections/${subsectionId}/documents/${fileId}`
        : `/api/investors/sections/${sectionId}/documents/${fileId}`;

      const response = await fetch(apiEndpoint, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' }
      });

      if (response.ok) {
        setSections(sections.map(section => {
          if (section._id === sectionId) {
            if (subsectionId) {
              return {
                ...section,
                subsections: section.subsections.map(subsection => {
                  if (subsection._id === subsectionId) {
                    if (subsubsectionId) {
                      return {
                        ...subsection,
                        subsubsections: subsection.subsubsections.map(subsub => {
                          if (subsub._id === subsubsectionId) {
                            return {
                              ...subsub,
                              documents: subsub.documents.filter(file => file._id !== fileId)
                            };
                          }
                          return subsub;
                        })
                      };
                    } else {
                      return {
                        ...subsection,
                        documents: subsection.documents.filter(file => file._id !== fileId)
                      };
                    }
                  }
                  return subsection;
                })
              };
            } else {
              return {
                ...section,
                documents: (section.documents || []).filter(file => file._id !== fileId)
              };
            }
          }
          return section;
        }));
      } else {
        console.error('Failed to delete file');
      }
    } else {
      console.error('Failed to get file details');
    }
  } catch (error) {
    console.error('Error deleting file:', error);
  }
};

// When admin clicks QR button on a file, store all context
const handleQrClick = async (file) => {
  console.log("entered qr click", file);
  try {
    const backendOrigin =
      process.env.NODE_ENV === "development"
        ? "http://localhost:4000"
        : window.location.origin;
    const qrTargetUrl =
      `${backendOrigin}/api/documents/redirect?fileUrl=${encodeURIComponent(file.docUrl)}`;
    console.log("qrtargeturl", qrTargetUrl);
    const qrBase64 = await QRCode.toDataURL(qrTargetUrl, {
      width: 300,
      margin: 0,
      color: {
        dark: "#000000",
        light: "#FFFFFF",
      },
    });

    setQrModalFile({
      name: file.name,
      qr: qrBase64
    });

  } catch (err) {
    console.error("Failed to generate QR:", err);
    alert("Unable to generate QR");
  }
};

const downloadQR = (qrBase64, name) => {
  const link = document.createElement("a");
  link.href = qrBase64;
  link.download = `${name}-qr.png`;
  link.click();
};


// const handleQrClick = (file, sectionId, subsectionId = null, subsubsectionId = null) => {
//   setQrModalFile({
//     ...file,
//     sectionId,
//     subsectionId,
//     subsubsectionId
//   });
// };

// const handleGenerateQr = async (file, sectionId, subsectionId, subsubsectionId) => {
//   try {
//     setIsGeneratingQrFor(file._id);

//     // Determine the correct endpoint based on the hierarchy
//     const endpoint = subsubsectionId
//       ? `/api/investors/sections/${sectionId}/subsections/${subsectionId}/subsubsections/${subsubsectionId}/documents/${file._id}/qr`
//       : subsectionId
//       ? `/api/investors/sections/${sectionId}/subsections/${subsectionId}/documents/${file._id}/qr`
//       : `/api/investors/sections/${sectionId}/documents/${file._id}/qr`;

//     const res = await fetch(endpoint, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         docUrl: file.docUrl,
//         name: file.name
//       })
//     });

//     if (!res.ok) {
//       const errorText = await res.text();
//       console.error('Failed to generate QR:', errorText);
//       alert('Failed to generate QR code. Please try again.');
//       return;
//     }

//     const updatedDoc = await res.json();

//     // Update sections state with the new QR code URL
//     setSections(prev =>
//       prev.map(section => {
//         if (section._id !== sectionId) return section;

//         // Handle top-level documents (directly under section)
//         if (!subsectionId) {
//           return {
//             ...section,
//             documents: (section.documents || []).map(doc =>
//               doc._id === file._id ? { ...doc, qrCodeUrl: updatedDoc.qrCodeUrl } : doc
//             )
//           };
//         }

//         // Handle subsection and subsubsection documents
//         return {
//           ...section,
//           subsections: section.subsections.map(sub => {
//             if (sub._id !== subsectionId) return sub;

//             if (subsubsectionId) {
//               // Update document in subsubsection
//               return {
//                 ...sub,
//                 subsubsections: sub.subsubsections.map(subsub => {
//                   if (subsub._id !== subsubsectionId) return subsub;
//                   return {
//                     ...subsub,
//                     documents: (subsub.documents || []).map(doc =>
//                       doc._id === file._id ? { ...doc, qrCodeUrl: updatedDoc.qrCodeUrl } : doc
//                     )
//                   };
//                 })
//               };
//             }

//             // Update document directly in subsection
//             return {
//               ...sub,
//               documents: (sub.documents || []).map(doc =>
//                 doc._id === file._id ? { ...doc, qrCodeUrl: updatedDoc.qrCodeUrl } : doc
//               )
//             };
//           })
//         };
//       })
//     );

//     // Update modal file to show the QR immediately
//     setQrModalFile(prev =>
//       prev && prev._id === file._id
//         ? { ...prev, qrCodeUrl: updatedDoc.qrCodeUrl }
//         : prev
//     );

//     console.log('QR code generated successfully:', updatedDoc.qrCodeUrl);
//   } catch (err) {
//     console.error('Error generating QR:', err);
//     alert('An error occurred while generating the QR code.');
//   } finally {
//     setIsGeneratingQrFor(null);
//   }
// };

const handleGenerateQr = async (file) => {
  try {
    setIsGeneratingQrFor(file._id); // for loading state

    // Generate Base64 QR from the document URL
    const qrBase64 = await QRCode.toDataURL(file.docUrl, {
      width: 300,
      margin: 1,
      color: {
        dark: "#000000",
        light: "#ffffff",
      },
    });

    // Show the QR preview in your modal
    setPreviewQr(qrBase64);

  } catch (error) {
    console.error("QR generation failed:", error);
    alert("Could not generate QR.");
  } finally {
    setIsGeneratingQrFor(null);
  }
};

const handleQrUploadPreview = (e) => {
  console.log('entered in qr part');
  const qfile = e.target.files[0];
  if (qfile) {
    const reader = new FileReader();
    reader.onload = () => setPreviewQr(reader.result);
    reader.readAsDataURL(qfile);
  }
};

const convertToBase64 = (fileOrBase64) => {
  return new Promise((resolve) => {
    // If already base64, return it directly
    if (typeof fileOrBase64 === "string" && fileOrBase64.startsWith("data:image")) {
      return resolve(fileOrBase64);
    }

    const reader = new FileReader();
    reader.readAsDataURL(fileOrBase64);
    reader.onload = () => resolve(reader.result);
  });
};

const uploadQrToCloudinary = async (base64Image) => {
  console.log("entered cloudin");
  const formData = new FormData();
  formData.append("file", base64Image);
  formData.append("upload_preset", "unsigned_upload"); // your unsigned preset

  const res = await fetch("https://api.cloudinary.com/v1_1/dccuq6ut4/upload", {
    method: "POST",
    body: formData,
  });

  const data = await res.json();
  return data.secure_url;   // return uploaded QR URL
};

const updateQrInTree = (sectionId, subsectionId, subsubsectionId, fileId, qrUrl) => {
  setSections((prev) =>
    prev.map((section) => {
      if (section._id !== sectionId) return section;

      // CASE 1: Document inside SECTION
      if (!subsectionId && !subsubsectionId) {
        return {
          ...section,
          documents: section.documents.map((doc) =>
            doc._id === fileId ? { ...doc, qrCodeUrl: qrUrl } : doc
          ),
        };
      }

      // CASE 2: Document inside SUBSECTION
      if (subsectionId && !subsubsectionId) {
        return {
          ...section,
          subsections: section.subsections.map((subsec) => {
            if (subsec._id !== subsectionId) return subsec;

            return {
              ...subsec,
              documents: subsec.documents.map((doc) =>
                doc._id === fileId ? { ...doc, qrCodeUrl: qrUrl } : doc
              ),
            };
          }),
        };
      }

      // CASE 3: Document inside SUBSUBSECTION
      return {
        ...section,
        subsections: section.subsections.map((subsec) => {
          if (subsec._id !== subsectionId) return subsec;

          return {
            ...subsec,
            subsubsections: subsec.subsubsections.map((subsub) => {
              if (subsub._id !== subsubsectionId) return subsub;

              return {
                ...subsub,
                documents: subsub.documents.map((doc) =>
                  doc._id === fileId ? { ...doc, qrCodeUrl: qrUrl } : doc
                ),
              };
            }),
          };
        }),
      };
    })
  );
};




const saveQr = async () => {
  if (!qrModalFile || !previewQr) return;

  try {
    // 1. Convert preview to base64 if needed
    const base64Image = await convertToBase64(previewQr);
    console.log("base64", base64Image);

    // 2. Upload directly to Cloudinary
    const qrUrl = await uploadQrToCloudinary(base64Image);
    console.log("qrurl", qrUrl);

    // 3. Save the Cloudinary URL to your backend DB
    const res = await fetch("/api/qr/save-url", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
         fileId: qrModalFile._id,
        sectionId: qrModalFile.sectionId,
        subsectionId: qrModalFile.subsectionId,
        subsubsectionId: qrModalFile.subsubsectionId,
        qrUrl
      }),
    });

    const data = await res.json();
    if (!data.success) {
      alert("Failed to save QR URL");
      return;
    }

     // 4. Update the main tree
    updateQrInTree(
      qrModalFile.sectionId,
      qrModalFile.subsectionId,
      qrModalFile.subsubsectionId,
      qrModalFile._id,
      qrUrl
    );

    // 5. Update the modal UI instantly
    setQrModalFile((prev) => ({ ...prev, qrCodeUrl: qrUrl }));

    
    setPreviewQr(null);
    closeQrModal();

    alert("QR saved successfully!");

  } catch (err) {
    console.error("Error saving QR:", err);
    alert("Something went wrong while saving QR.");
  }
};





const closeQrModal = () => {
  setQrModalFile(null);
  setPreviewQr(null);
};


  const FileUploadZone = ({ sectionId, subsectionId = null, subsubsectionId = null, files = [] }) => {
    const [isDragOver, setIsDragOver] = useState(false);

    const handleDragOver = (e) => {
      e.preventDefault();
      setIsDragOver(true);
    };

    const handleDragLeave = (e) => {
      e.preventDefault();
      setIsDragOver(false);
    };

    const handleDrop = (e) => {
      e.preventDefault();
      setIsDragOver(false);
      const files = e.dataTransfer.files;
      //handleFileUpload(sectionId, subsectionId, subsubsectionId, files);
      handleFileUpload(sectionId, subsectionId, files, subsubsectionId);
    };

    return (
      <div className="file-management">
        <div
          className={`upload-zone ${isDragOver ? 'drag-over' : ''}`}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          <input
            type="file"
            multiple
            accept=".pdf, .doc, .docx, .html, .xls, .xlsx"
            onChange={(e) => handleFileUpload(sectionId, subsectionId, e.target.files, subsubsectionId)}
            className="file-input"
            //id={`file-${sectionId}-${subsectionId || 'main'}`}
            id={`file-${sectionId}-${subsectionId || 'main'}-${subsubsectionId || 'none'}`}
          />
          <label htmlFor={`file-${sectionId}-${subsectionId || 'main'}-${subsubsectionId || 'none'}`} className="upload-label">
            <Upload className="upload-icon" />
            <span className="upload-text">
              <strong>Click to upload</strong> or drag and drop files here
            </span>
            <span className="upload-subtext">PDF, DOC, DOCX files</span>
          </label>
        </div>

        {files.length > 0 && (
          <div className="files-list">
            <h4 className="files-title">Uploaded Files ({files.length})</h4>
            {files.map(file => (
              <div key={file._id} className="file-item">
                <div className="file-info">
                  <FileText className="file-icon" />
                  <div className="file-details">
                    <span className="file-name">{file.name}</span>
                    {/* <span className="file-meta">{file.size} • {file.uploadDate}</span> */}
                  </div>
                </div>
                <div className="file-actions">
                   <button className="action-btn view-btn"
                    title={file.qrCodeUrl ? 'View QR' : 'Add or Generate QR'}
                     onClick={() =>
                      //handleQrClick(file, sectionId, subsectionId, subsubsectionId)
                       handleQrClick(file)
                      }
                    >
                      <QrCode size={16} />
                   </button>
                  
                  <button className="action-btn download-btn" title="Download" onClick={() => handleDocumentClick(file)}>
                    <Download size={16} />
                  </button>
                  <button 
                    className="action-btn delete-btn" 
                    title="Delete"
                    onClick={() => deleteFile(sectionId, subsectionId, file._id, subsubsectionId)}
                  >
                    <Trash2 size={16} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };
 return (
  <div className="admin-investors-panel">
    <div className="panel-header">
      <div className="header-content">
        <h1 className="panel-title">Investors Document Management</h1>
        <p className="panel-subtitle">Manage sections, subsections, and upload documents for investors</p>
      </div>
      {/* <button 
        className="add-section-btn"
        onClick={() => setShowAddSection(true)}
      >
        <FolderPlus size={20} />
        Add New Section
      </button> */}
    </div>

    {showAddSection && (
      <div className="add-section-form">
        <div className="form-content">
          <input
            type="text"
            placeholder="Enter section name (e.g., Leadership, Policies)"
            value={newSectionName}
            onChange={(e) => setNewSectionName(e.target.value)}
            className="section-input"
            autoFocus
          />
          <div className="form-actions">
            <button className="save-btn" onClick={addSection}>
              <Save size={16} />
              Save Section
            </button>
            <button 
              className="cancel-btn" 
              onClick={() => {
                setShowAddSection(false);
                setNewSectionName('');
              }}
            >
              <X size={16} />
              Cancel
            </button>
          </div>
        </div>
      </div>
    )}

    <div className="sections-container">
      {Array.isArray(sections) && sections.map(section => (
        <div key={section._id} className="section-card">
          <div className="section-header">
            <div className="section-info">
              <h2 className="section-name">{section.secname}</h2>
              {/* <span className="section-stats">
                {(section.subsections?.length || 0)} subsections - {(section.documents?.length || 0) + (section.subsections?.reduce((acc, sub) => acc + (sub.documents?.length || 0), 0) || 0)} files
              </span> */}
            </div>
            <div className="section-actions">
              <button 
                className="action-btn edit-btn"
                onClick={() => setShowAddSubsection(section._id)}
              >
                <Plus size={16} />
                Add Subsection
              </button>
              {/* <button 
                className="action-btn edit-btn"
                onClick={() => setEditingSection(section._id)}
              >
                <Edit3 size={16} />
              </button> */}
              <button 
                className="action-btn delete-btn"
                onClick={() => deleteSection(section._id)}
              >
                <Trash2 size={16} />
              </button>
            </div>
          </div>

          {showAddSubsection === section._id && (
            <div className="add-subsection-form">
              <input
                type="text"
                placeholder="Enter subsection name"
                value={newSubsectionName}
                onChange={(e) => setNewSubsectionName(e.target.value)}
                className="subsection-input"
              />
              <div className="form-actions">
                <button 
                  className="save-btn small"
                  onClick={() => addSubsection(section._id)}
                >
                  <Save size={14} />
                  Add
                </button>
                <button 
                  className="cancel-btn small"
                  onClick={() => {
                    setShowAddSubsection(null);
                    setNewSubsectionName('');
                  }}
                >
                  <X size={14} />
                </button>
              </div>  
            </div>
          )}

          <div className="section-content">
            {/* Direct files under section - only show if no subsections */}
            {(!section.subsections || section.subsections.length === 0) && (
              <div className="direct-files">
                <h3 className="content-title">Section Files</h3>
                <FileUploadZone 
                  sectionId={section._id} 
                  files={section.documents || []} 
                />
              </div>
            )}

            {/* Subsections */}
          {section.subsections?.map(subsection => {
    const isOpen = openSubsectionId === subsection._id;

    const directDocsCount = subsection.documents?.length || 0;
    const subsubDocsCount =
      subsection.subsubsections?.reduce(
        (acc, subsub) => acc + (subsub.documents?.length || 0),
        0
      ) || 0;
    const totalDocsCount = directDocsCount + subsubDocsCount;

    return (
      <div key={subsection._id} className="subsection-card">
        <div className="subsection-header">
          <div
            className="subsection-info"
            onClick={() =>
              setOpenSubsectionId(isOpen ? null : subsection._id)
            }
            style={{ cursor: 'pointer' }}
          >
            <h3 className="subsection-name">{subsection.subsecname}</h3>
            <span className="subsection-stats">
              {totalDocsCount} files
            </span>
          </div>

          <div className="subsection-actions">
            {/* dropdown chevron for subsection */}
            <button
              className="action-btn small"
              onClick={() =>
                setOpenSubsectionId(isOpen ? null : subsection._id)
              }
            >
              {isOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
            </button>

            <button
              className="action-btn edit-btn"
              onClick={() => setShowAddSubsubsection(subsection._id)}
            >
              <Plus size={16} />
              Add Subsection
            </button>
            {/* <button
              className="action-btn edit-btn small"
              onClick={() => setEditingSubsection(subsection._id)}
            >
              <Edit3 size={14} />
            </button> */}
            <button
              className="action-btn delete-btn small"
              onClick={() =>
                deleteSubsection(section._id, subsection._id)
              }
            >
              <Trash2 size={14} />
            </button>
          </div>
        </div>

        {isOpen && (
          <>
            {/* Add subsubsection form */}
            {showAddSubsubsection === subsection._id && (
              <div className="add-subsection-form">
                <input
                  type="text"
                  placeholder="Enter subsubsection name"
                  value={newSubsubsectionName}
                  onChange={(e) =>
                    setNewSubsubsectionName(e.target.value)
                  }
                  className="subsection-input"
                />
                <div className="form-actions">
                  <button
                    className="save-btn small"
                    onClick={() =>
                      addSubsubsection(section._id, subsection._id)
                    }
                  >
                    <Save size={14} />
                    Add
                  </button>
                  <button
                    className="cancel-btn small"
                    onClick={() => {
                      setShowAddSubsubsection(null);
                      setNewSubsubsectionName('');
                    }}
                  >
                    <X size={14} />
                  </button>
                </div>
              </div>
            )}

            {/* Subsection file upload zone - only show if no subsubsections */}
            {(!subsection.subsubsections ||
              subsection.subsubsections.length === 0) && (
              <FileUploadZone
                sectionId={section._id}
                subsectionId={subsection._id}
                files={subsection.documents || []}
              />
            )}

            {/* Subsubsections */}
            {subsection.subsubsections?.map(subsubsection => {
              const isSubsubOpen =
                openSubsubsectionId === subsubsection._id;

              return (
                <div
                  key={subsubsection._id}
                  className="subsubsection-card"
                >
                  <div className="subsection-header">
                    <div
                      className="subsection-info"
                      onClick={() =>
                        setOpenSubsubsectionId(
                          isSubsubOpen ? null : subsubsection._id
                        )
                      }
                      style={{ cursor: 'pointer' }}
                    >
                      <h4 className="subsection-name">
                        {subsubsection.subsubsecname}
                      </h4>
                      <span className="subsection-stats">
                        {subsubsection.documents?.length || 0} files
                      </span>
                    </div>
                    <div className="subsection-actions">
                      {/* dropdown chevron for subsubsection */}
                      <button
                        className="action-btn small"
                        onClick={() =>
                          setOpenSubsubsectionId(
                            isSubsubOpen ? null : subsubsection._id
                          )
                        }
                      >
                        {isSubsubOpen ? (
                          <ChevronUp size={16} />
                        ) : (
                          <ChevronDown size={16} />
                        )}
                      </button>

                      {/* <button
                        className="action-btn edit-btn small"
                        onClick={() =>
                          setEditingSubsubsection(subsubsection._id)
                        }
                      >
                        <Edit3 size={14} />
                      </button> */}
                      <button
                        className="action-btn delete-btn small"
                        onClick={() =>
                          deleteSubsubsection(
                            section._id,
                            subsection._id,
                            subsubsection._id
                          )
                        }
                      >
                        <Trash2 size={14} />
                      </button>
                    </div>
                  </div>

                  {isSubsubOpen && (
                    <FileUploadZone
                      sectionId={section._id}
                      subsectionId={subsection._id}
                      subsubsectionId={subsubsection._id}
                      files={subsubsection.documents || []}
                    />
                  )}
                </div>
              );
            })}
          </>
        )}
      </div>
    );
  })}
             {/* {section.subsections?.map(subsection => {
    const isOpen = openSubsectionId === subsection._id;

    return (
      <div key={subsection._id} className="subsection-card">
        <div className="subsection-header">
          <div
            className="subsection-info"
            onClick={() =>
              setOpenSubsectionId(isOpen ? null : subsection._id)
            }
            style={{ cursor: 'pointer' }}
          >
            <h3 className="subsection-name">{subsection.subsecname}</h3>
            <span className="subsection-stats">
              {subsection.documents?.length || 0} files
            </span>
          </div>

          <div className="subsection-actions">
           
            <button
              className="action-btn small"
              onClick={() =>
                setOpenSubsectionId(isOpen ? null : subsection._id)
              }
            >
              {isOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
            </button>

            <button
              className="action-btn edit-btn"
              onClick={() => setShowAddSubsubsection(subsection._id)}
            >
              <Plus size={16} />
              Add Subsection
            </button>
            <button
              className="action-btn edit-btn small"
              onClick={() => setEditingSubsection(subsection._id)}
            >
              <Edit3 size={14} />
            </button>
            <button
              className="action-btn delete-btn small"
              onClick={() =>
                deleteSubsection(section._id, subsection._id)
              }
            >
              <Trash2 size={14} />
            </button>
          </div>
        </div>

        {isOpen && (
          <>
          
            {showAddSubsubsection === subsection._id && (
              <div className="add-subsection-form">
                <input
                  type="text"
                  placeholder="Enter subsubsection name"
                  value={newSubsubsectionName}
                  onChange={(e) =>
                    setNewSubsubsectionName(e.target.value)
                  }
                  className="subsection-input"
                />
                <div className="form-actions">
                  <button
                    className="save-btn small"
                    onClick={() =>
                      addSubsubsection(section._id, subsection._id)
                    }
                  >
                    <Save size={14} />
                    Add
                  </button>
                  <button
                    className="cancel-btn small"
                    onClick={() => {
                      setShowAddSubsubsection(null);
                      setNewSubsubsectionName('');
                    }}
                  >
                    <X size={14} />
                  </button>
                </div>
              </div>
            )}

           
            {(!subsection.subsubsections ||
              subsection.subsubsections.length === 0) && (
              <FileUploadZone
                sectionId={section._id}
                subsectionId={subsection._id}
                files={subsection.documents || []}
              />
            )}

           
            {subsection.subsubsections?.map(subsubsection => (
              <div
                key={subsubsection._id}
                className="subsubsection-card"
              >
                <div className="subsection-header">
                  <div className="subsection-info">
                    <h4 className="subsection-name">
                      {subsubsection.subsubsecname}
                    </h4>
                    <span className="subsection-stats">
                      {subsubsection.documents?.length || 0} files
                    </span>
                  </div>
                  <div className="subsection-actions">
                    <button
                      className="action-btn edit-btn small"
                      onClick={() =>
                        setEditingSubsubsection(subsubsection._id)
                      }
                    >
                      <Edit3 size={14} />
                    </button>
                    <button
                      className="action-btn delete-btn small"
                      onClick={() =>
                        deleteSubsubsection(
                          section._id,
                          subsection._id,
                          subsubsection._id
                        )
                      }
                    >
                      <Trash2 size={14} />
                    </button>
                  </div>
                </div>

                <FileUploadZone
                  sectionId={section._id}
                  subsectionId={subsection._id}
                  subsubsectionId={subsubsection._id}
                  files={subsubsection.documents || []}
                />
              </div>
            ))}
          </>
        )}
      </div>
    );
  })} */}
            {/* {section.subsections?.map(subsection => (
             
              <div key={subsection._id} className="subsection-card">
                <div className="subsection-header">
                  <div className="subsection-info">
                    <h3 className="subsection-name">{subsection.subsecname}</h3>
                    <span className="subsection-stats">{subsection.documents?.length || 0} files</span>
                  </div>
                  <div className="subsection-actions">
                    <button 
                      className="action-btn edit-btn"
                      onClick={() => setShowAddSubsubsection(subsection._id)}
                    >
                      <Plus size={16} />
                      Add Subsection
                    </button>
                    <button 
                      className="action-btn edit-btn small"
                      onClick={() => setEditingSubsection(subsection._id)}
                    >
                      <Edit3 size={14} />
                    </button>
                    <button 
                      className="action-btn delete-btn small"
                      onClick={() => deleteSubsection(section._id, subsection._id)}
                    >
                      <Trash2 size={14} />
                    </button>
                  </div>
                </div>

                {/* Add subsubsection form 
                {showAddSubsubsection === subsection._id && (
                  <div className="add-subsection-form">
                    <input
                      type="text"
                      placeholder="Enter subsubsection name"
                      value={newSubsubsectionName}
                      onChange={(e) => setNewSubsubsectionName(e.target.value)}
                      className="subsection-input"
                    />
                    <div className="form-actions">
                      <button 
                        className="save-btn small"
                        onClick={() => addSubsubsection(section._id, subsection._id)}
                      >
                        <Save size={14} />
                        Add
                      </button>
                      <button 
                        className="cancel-btn small"
                        onClick={() => {
                          setShowAddSubsubsection(null);
                          setNewSubsubsectionName('');
                        }}
                      >
                        <X size={14} />
                      </button>
                    </div>  
                  </div>
                )}

              
                {(!subsection.subsubsections || subsection.subsubsections.length === 0) && (
                  <FileUploadZone 
                    sectionId={section._id} 
                    subsectionId={subsection._id}
                    files={subsection.documents || []} 
                  />
                )}

               
                {subsection.subsubsections?.map(subsubsection => (
                  <div key={subsubsection._id} className="subsubsection-card">
                    <div className="subsection-header">
                      <div className="subsection-info">
                        <h4 className="subsection-name">{subsubsection.subsubsecname}</h4>
                        <span className="subsection-stats">{subsubsection.documents?.length || 0} files</span>
                      </div>
                      <div className="subsection-actions">
                        <button 
                          className="action-btn edit-btn small"
                          onClick={() => setEditingSubsubsection(subsubsection._id)}
                        >
                          <Edit3 size={14} />
                        </button>
                        <button 
                          className="action-btn delete-btn small"
                          onClick={() => deleteSubsubsection(section._id, subsection._id, subsubsection._id)}
                        >
                          <Trash2 size={14} />
                        </button>
                      </div>
                    </div>
                    
                    <FileUploadZone 
                      sectionId={section._id} 
                      subsectionId={subsection._id}
                      subsubsectionId={subsubsection._id}
                      files={subsubsection.documents || []} 
                    />
                  </div>
                ))}
              </div>
            ))} */}
          </div>
        </div>
      ))}
    </div>

         {/* qr code handling */}
         {qrModalFile && (
  <div className="qr-modal-overlay" onClick={closeQrModal}>
     <div className="qr-modal" onClick={(e) => e.stopPropagation()}>

      <button className="qr-close-btn" onClick={closeQrModal}>×</button>

      <h3 className="qr-title">{qrModalFile.name}</h3>

      <img
        src={qrModalFile.qr}
        alt="QR Code"
        className="qr-image"
      />

      <p className="qr-text">Scan to open document</p>

      <button
        className="qr-btn secondary"
        onClick={() => downloadQR(qrModalFile.qr, qrModalFile.name)}
      >
        Download QR
      </button>

    </div>
    {/* <div className="qr-modal" onClick={(e) => e.stopPropagation()}>
      
      {/* Close Button 
      <button className="qr-close-btn" onClick={closeQrModal}>×</button>

      <h3 className="qr-title">{qrModalFile.name}</h3>

      {/* CASE 1: QR already exists 
      {qrModalFile.qrCodeUrl && !previewQr && (
        <>
          <img
            src={qrModalFile.qrCodeUrl}
            alt="QR Code"
            className="qr-image"
          />
          <p className="qr-text">This document already has a QR code.</p>
        </>
      )}

      {/* CASE 2: No QR exists — Show Add QR + Generate QR 
      {!qrModalFile.qrCodeUrl && !previewQr && (
        <>
          <p className="qr-text">No QR exists for this document yet.</p>

          <button
            className="qr-btn primary"
            disabled={isGeneratingQrFor === qrModalFile._id}
            onClick={() =>
              handleGenerateQr(
                qrModalFile
                //qrModalFile.sectionId,
                //qrModalFile.subsectionId,
                //qrModalFile.subsubsectionId
              )
            }
          >
            {isGeneratingQrFor === qrModalFile._id ? "Generating..." : "Generate QR"}
          </button>

          <button className="qr-btn secondary" onClick={() => document.getElementById("qrUploadInput").click()} >
            Add QR
          </button>

          <input type="file"
               id="qrUploadInput"
               accept="image/*"
               style={{ display: "none" }}
               onChange={handleQrUploadPreview}
          />
        </>
      )}

      {/* CASE 3 & 4: Show preview when admin adds QR OR generate QR 
      {previewQr && (
        <>
          <img src={previewQr} className="qr-image" alt="QR Preview" />
          <p className="qr-text">Preview your QR code</p>

          <button
            className="qr-btn primary"
            onClick={() => saveQr(previewQr)}
          >
            Save QR
          </button>
        </>
      )}
    </div> */}

    {/* Inline CSS */}
    <style>{`
      .qr-modal-overlay {
        position: fixed;
        inset: 0;
        background: rgba(0,0,0,0.55);
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px;
        z-index: 1000;
      }

      .qr-modal {
        position: relative;
        background: rgba(255, 255, 255, 0.15);
        backdrop-filter: blur(12px);
        padding: 30px;
        border-radius: 16px;
        width: 350px;
        text-align: center;
        box-shadow: 0 8px 25px rgba(0,0,0,0.25);
        animation: fadeIn 0.2s ease-out;
      }

      @keyframes fadeIn {
        from { opacity: 0; transform: scale(0.9); }
        to { opacity: 1; transform: scale(1); }
      }

      .qr-close-btn {
        position: absolute;
        top: 12px;
        right: 12px;
        background: none;
        border: none;
        font-size: 22px;
        font-weight: bold;
        cursor: pointer;
        color: white;
      }

      .qr-title {
        margin-bottom: 1rem;
        font-size: 1.2rem;
        font-weight: 600;
        color: white;
      }

      .qr-text {
        color: #f1f1f1;
        margin-bottom: 1rem;
      }

      .qr-image {
        width: 200px;
        height: 200px;
        object-fit: contain;
        margin-bottom: 1rem;
        border-radius: 8px;
        background: white;
        padding: 10px;
      }

      .qr-btn {
        padding: 10px 18px;
        border-radius: 8px;
        font-size: 14px;
        border: none;
        cursor: pointer;
        margin-bottom: 10px;
        width: 100%;
        display: inline-block;
      }

      .qr-btn.primary {
        background: #007bff;
        color: white;
        font-weight: 600;
      }

      .qr-btn.secondary {
        background: #ffffff;
        color: #333;
        font-weight: 600;
        // border: 1px solid #ddd;
      }

      .qr-btn.primary:disabled {
        background: #7daff7;
        cursor: not-allowed;
      }
    `}</style>
  </div>
)}

  {/* {qrModalFile && (
  <div className="qr-modal-overlay" onClick={closeQrModal}>
    <div
      className="qr-modal"
      onClick={(e) => e.stopPropagation()}
    >
      <h3 style={{ marginBottom: '1rem' }}>{qrModalFile.name}</h3>

      {qrModalFile.qrCodeUrl ? (
        <>
          <img
            src={qrModalFile.qrCodeUrl}
            alt="QR code"
            style={{ width: 200, height: 200, marginBottom: '1rem' }}
          />
          <p>This document already has a QR code.</p>
        </>
      ) : (
        <>
          <p style={{ marginBottom: '1rem' }}>
            No QR exists for this document yet.
          </p>
          <button
            className="save-btn small"
            disabled={isGeneratingQrFor === qrModalFile._id}
            onClick={() =>
              handleGenerateQr(
                qrModalFile,
                qrModalFile.sectionId,
                qrModalFile.subsectionId,
                qrModalFile.subsubsectionId
              )
            }
          >
            {isGeneratingQrFor === qrModalFile._id ? 'Generating...' : 'Generate QR'}
          </button>
        </>
      )}

      <button
        className="cancel-btn small"
        style={{ marginTop: '1rem' }}
        onClick={closeQrModal}
      >
        Close
      </button>
    </div>
  </div>
)} */}



  

      <style jsx>{`
        .admin-investors-panel {
          min-height: 100vh;
          background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
          padding: 2rem;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
        }

        .panel-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 2rem;
          background: white;
          padding: 2rem;
          border-radius: 16px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
          border: 1px solid rgba(0, 0, 0, 0.05);
        }

        .header-content {
          flex: 1;
        }

        .panel-title {
          font-size: 2.5rem;
          font-weight: 700;
          color: #2d3748;
          margin: 0 0 0.5rem 0;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .panel-subtitle {
          color: #718096;
          font-size: 1.1rem;
          margin: 0;
        }

        .add-section-btn {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          border: none;
          padding: 1rem 2rem;
          border-radius: 12px;
          font-weight: 600;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          transition: all 0.3s ease;
          font-size: 1rem;
        }

        .add-section-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
        }

        .add-section-form {
          background: white;
          border-radius: 12px;
          padding: 1.5rem;
          margin-bottom: 2rem;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
          border: 2px solid #667eea;
        }

        .form-content {
          display: flex;
          gap: 1rem;
          align-items: center;
        }

        .section-input, .subsection-input {
          flex: 1;
          padding: 1rem;
          border: 2px solid #e2e8f0;
          border-radius: 8px;
          font-size: 1rem;
          transition: border-color 0.3s ease;
        }

        .section-input:focus, .subsection-input:focus {
          outline: none;
          border-color: #667eea;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
        }

        .form-actions {
          display: flex;
          gap: 0.5rem;
        }

        .save-btn {
          background: #48bb78;
          color: white;
          border: none;
          padding: 1rem 1.5rem;
          border-radius: 8px;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-weight: 500;
          transition: all 0.3s ease;
        }

        .save-btn:hover {
          background: #38a169;
          transform: translateY(-1px);
        }

        .save-btn.small {
          padding: 0.75rem 1rem;
          font-size: 0.9rem;
        }

        .cancel-btn {
          background: white;
          color: #e53e3e;
          border: 2px solid #e53e3e;
          padding: 1rem 1.5rem;
          border-radius: 8px;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-weight: 500;
          transition: all 0.3s ease;
        }

        .cancel-btn:hover {
          background: #e53e3e;
          color: white;
        }

        .cancel-btn.small {
          padding: 0.75rem 1rem;
          font-size: 0.9rem;
        }

        .sections-container {
          display: flex;
          flex-direction: column;
          gap: 2rem;
        }

        .section-card {
          background: white;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
          border: 1px solid rgba(0, 0, 0, 0.05);
          margin-top: 2rem;
        }

        .section-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 2rem;
          background: linear-gradient(135deg, #f8f9ff 0%, #e8ecff 100%);
          border-bottom: 1px solid rgba(102, 126, 234, 0.2);
        }

        .section-info {
          flex: 1;
        }

        .section-name {
          font-size: 1.8rem;
          font-weight: 700;
          color: #2d3748;
          margin: 0 0 0.5rem 0;
        }

        .section-stats {
          color: #718096;
          font-size: 0.9rem;
        }

        .section-actions {
          display: flex;
          gap: 0.5rem;
        }

        .action-btn {
          padding: 0.75rem;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
        }

        .action-btn.small {
          padding: 0.5rem;
        }

        .edit-btn {
          background: rgba(52, 152, 219, 0.1);
          color: #3498db;
        }

        .edit-btn:hover {
          background: #3498db;
          color: white;
          transform: translateY(-2px);
        }

        .delete-btn {
          background: rgba(231, 76, 60, 0.1);
          color: #e74c3c;
        }

        .delete-btn:hover {
          background: #e74c3c;
          color: white;
          transform: translateY(-2px);
        }

        .view-btn {
          background: rgba(155, 89, 182, 0.1);
          color: #9b59b6;
        }

        .view-btn:hover {
          background: #9b59b6;
          color: white;
        }

        .download-btn {
          background: rgba(46, 204, 113, 0.1);
          color: #2ecc71;
        }

        .download-btn:hover {
          background: #2ecc71;
          color: white;
        }

        .add-subsection-form {
          padding: 1.5rem;
          background: rgba(102, 126, 234, 0.02);
          border-bottom: 1px solid rgba(102, 126, 234, 0.1);
        }

        .section-content {
          padding: 2rem;
        }

        .direct-files {
          margin-bottom: 2rem;
        }

        .content-title {
          font-size: 1.4rem;
          font-weight: 600;
          color: #2d3748;
          margin-bottom: 1rem;
        }

        .subsection-card {
          background: #f8f9fa;
          border-radius: 12px;
          margin-bottom: 2rem;
          border: 1px solid #e9ecef;
        }

        .subsection-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1.5rem;
          background: white;
          border-bottom: 1px solid #e9ecef;
          border-radius: 12px 12px 0 0;
        }

        .subsection-name {
          font-size: 1.3rem;
          font-weight: 600;
          color: #2d3748;
          margin: 0 0 0.25rem 0;
        }

        .subsection-stats {
          color: #718096;
          font-size: 0.9rem;
        }

        .subsection-actions {
          display: flex;
          gap: 0.5rem;
        }

         .subsubsection-card {
          top: 10px;
          background: #f8f9fa;
          border-radius: 12px;
          margin-bottom: 2rem;
          border: 1px solid #e9ecef;
        }

        .file-management {
          margin: 1.5rem 0;
        }

        .upload-zone {
          border: 2px dashed #cbd5e0;
          border-radius: 12px;
          padding: 3rem;
          text-align: center;
          background: #f7fafc;
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .upload-zone:hover, .upload-zone.drag-over {
          border-color: #667eea;
          background: rgba(102, 126, 234, 0.05);
        }

        .file-input {
          display: none;
        }

        .upload-label {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 1rem;
          cursor: pointer;
        }

        .upload-icon {
          color: #667eea;
          margin-bottom: 0.5rem;
        }

        .upload-text {
          font-size: 1.1rem;
          color: #4a5568;
        }

        .upload-subtext {
          font-size: 0.9rem;
          color: #718096;
        }

        .files-list {
          margin-top: 2rem;
        }

        .files-title {
          font-size: 1.2rem;
          font-weight: 600;
          color: #2d3748;
          margin-bottom: 1rem;
        }

        .file-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1rem;
          background: white;
          border-radius: 8px;
          margin-bottom: 0.75rem;
          border: 1px solid #e2e8f0;
          transition: all 0.3s ease;
        }

        .file-item:hover {
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          transform: translateY(-1px);
        }

        .file-info {
          display: flex;
          align-items: center;
          gap: 1rem;
          flex: 1;
        }

        .file-icon {
          color: #e53e3e;
        }

        .file-details {
          display: flex;
          flex-direction: column;
        }

        .file-name {
          font-weight: 500;
          color: #2d3748;
          margin-bottom: 0.25rem;
        }

        .file-meta {
          font-size: 0.85rem;
          color: #718096;
        }

        .file-actions {
          display: flex;
          gap: 0.5rem;
        }

       

        @media (max-width: 768px) {
          .admin-investors-panel {
            padding: 1rem;
          }

          .panel-header {
            flex-direction: column;
            gap: 1rem;
            align-items: stretch;
          }

          .form-content {
            flex-direction: column;
          }

          .section-header {
            flex-direction: column;
            gap: 1rem;
            align-items: stretch;
          }

          .subsection-header {
            flex-direction: column;
            gap: 1rem;
            align-items: stretch;
          }

          .file-item {
            flex-direction: column;
            gap: 1rem;
            align-items: stretch;
          }

          

        }
      `}</style>
    </div>
  );
};

export default Investors;

